<script setup lang="ts">
interface Props {
    duration: number;
    paused: boolean;
}

defineProps<Props>();
</script>

<template>
    <div data-slot="toast-progress" class="toast-progress">
        <div
            class="toast-progress__bar"
            :data-paused="paused || undefined"
            :style="{ '--toast-duration': `${duration}ms` }"
        />
    </div>
</template>
